// extracted by mini-css-extract-plugin
export default {"container":"_2nBbDFI-XN5pAcTJxRbPyH","heading":"_2huBBu7Aru5mRyZXn3UubA","templates":"_2MNm6iyqcqPKXfbOouu3T0","tags":"_7XTOlCzErMZbYa-RKsYsr","tag":"_1aRya_489NzRDCgYJ2vBop"};